<template>
  <div>
    <main class="main reception failure-page">
      <div class="section top">
        <div class="top__headline">
          <h2>고객님 죄송합니다.</h2>
        </div>
        <div class="top__sub-headline">
          <h4>
            고객님은 아래의 사유로 아직
            <br />비상금 서비스 이용이 불가합니다
          </h4>
        </div>
      </div>
      <div class="section failure">
        <div class="failure--rectangle">
          <div class="paragraph">
            <h3>{{title}}</h3>
            <h4>{{reason}}</h4>
          </div>
        </div>
      </div>
      <div class="section bottom">
        <button
          v-ripple
          class="button next-button"
          type="button"
          @click="$router.push({name: 'dashboard'})"
        >확인</button>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.commit('ui/headerTitle', '카드매출 불러오기')
  },
  props: {
    title: String,
    reason: String
  }
}
</script>
